module.exports = __webpack_public_path__ + "img/icon.25510d42.png";